import { render, staticRenderFns } from "./AlertMsg.vue?vue&type=template&id=50c1e220&"
import script from "./AlertMsg.vue?vue&type=script&lang=js&"
export * from "./AlertMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports